import { useEffect, useState } from 'react'

interface UseCountdownProps {
  initialSeconds: number
  interval?: number
  forceReset?: boolean
}

export const useCountdown = ({
  initialSeconds,
  interval = 1000,
  forceReset = false,
}: UseCountdownProps) => {
  const [seconds, setSeconds] = useState(initialSeconds)
  const [isRunning, setIsRunning] = useState(false)

  useEffect(() => {
    let countdownInterval: NodeJS.Timeout | null = null

    if (isRunning) {
      countdownInterval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(prevSeconds => prevSeconds - 1)
        }
      }, interval)
    }

    if (forceReset) {
      reset()
    }

    return () => {
      if (countdownInterval) {
        clearInterval(countdownInterval)
      }
    }
  }, [interval, isRunning, seconds, forceReset])

  useEffect(() => {
    start()
  }, [])

  const start = () => {
    setIsRunning(true)
  }

  const pause = () => {
    setIsRunning(false)
    setSeconds(seconds)
  }

  const reset = () => {
    setIsRunning(true)
    setSeconds(initialSeconds)
  }

  return { seconds, start, pause, reset }
}
